'use client';

import { useTripId } from '~/hooks/useTripId';
import { api } from '~/libs/api';

export const useHasUnavailableStay = () => {
  const tripId = useTripId();
  const { data: liveCheck } = api.trip.liveCheck.useQuery({ tripId, replaceUnavailable: false }, { enabled: false });

  return liveCheck?.liveCheckOutcome.stays.some((stay) => stay.availabilityStatus === 'UNAVAILABLE') ?? false;
};
